/**
 * Feature-local TanStack QueryClient per wallet (F-009.3).
 *
 * Il codebase non ha un QueryClient globale: ogni feature scopa il suo
 * (cfr. `features/admin-wallet/lib/query-client.ts`). Montato per-pagina da
 * `WalletPage` via `QueryClientProvider`. Singleton di modulo così summary e
 * transactions condividono cache/invalidazione nella stessa sessione SPA.
 */
import { QueryClient } from '@tanstack/react-query';

export function createWalletQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: { retry: 0 },
    },
  });
}

export const walletQueryClient = createWalletQueryClient();

/** Query key condivise per summary + storico (invalidazione coerente). */
export const walletQueryKeys = {
  summary: ['wallet', 'summary'] as const,
  transactions: (filters: unknown) => ['wallet', 'transactions', filters] as const,
};
